export default __webpack_public_path__ + "static/n3-4094a1c0ee6875197dba126072ae5875.jpg";